// extracted by mini-css-extract-plugin
module.exports = {"root":"IconEmailAttention_root__1bgBL","marketplaceStroke":"IconEmailAttention_marketplaceStroke__2URga","attentionStroke":"IconEmailAttention_attentionStroke__20klo"};